import { SxStyles } from '../../../types';
import { getResponsiveSize } from '../../../utils';

export const DeviceDialogStyle: SxStyles = {
  // Applied via ModalUI's `wrapperSx` prop — i.e. directly to the
  // `.modal-wrapper` Box, so the width/padding constraints actually take
  // effect instead of being merged into the outer Modal's sx via a nested
  // descendant selector.
  deviceModal: {
    width: getResponsiveSize(400),
    // Hard-cap the width so a long selected-option label (e.g. a verbose
    // "Communications - Headset Microphone …" device name) can't push the
    // modal wider than its intended size.
    maxWidth: getResponsiveSize(400),
    boxSizing: 'border-box',
    borderRadius: getResponsiveSize(16),
    overflow: 'hidden',
    backgroundColor: '#FCFCFC',
    p: getResponsiveSize(12),
    // Truncate the displayed Select value with an ellipsis so long device
    // names don't widen the layout. Full label is still visible in the
    // dropdown menu items and via the Tooltip on the Select itself.
    '& .MuiSelect-select': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minWidth: 0,
    },
    // Keep the FormControl from forcing min-content sizing.
    '& .MuiFormControl-root': {
      minWidth: 0,
    },
    // Constrain the legacy `.inputSelect` wrapper too so nothing inside
    // can blow out the modal width. NOTE: no `overflow: hidden` here —
    // MUI's `InputLabel` with `shrink` sits ~9px above the FormControl
    // border and gets clipped if the wrapper hides overflow.
    '& .inputSelect': {
      width: '100%',
      minWidth: 0,
    },
  },
  // Practitioner variant — shifts the modal to sit in the centre of the
  // video area (the page reserves ~27% on the right for the EMDR panel,
  // with a hard min-width of 330px). `min(...)` keeps centering correct
  // on both wide and narrow screens. Merged into the wrapperSx so it
  // overrides the default `left: 50%` from the base modal style.
  deviceModalVideoArea: {
    left: 'min(36.5%, calc(50% - 165px))',
  },
  // Action row — keeps the DONE button right-aligned, with a small top
  // margin separating it from the selectors. `width: 100%` ensures the row
  // spans the full modal content area so the button aligns to the modal's
  // padding edge instead of the (narrower) DialogContent above it.
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    mt: getResponsiveSize(8),
  },
};
